var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0423 20.2643C17.2433 20.0634 17.3664 19.7841 17.366 19.4774L17.366 19.3424C17.366 18.7282 16.8688 18.231 16.2554 18.2318L10.187 18.2318L20.4523 7.96648C20.8859 7.53294 20.8859 6.82923 20.4523 6.39569C20.0188 5.96216 19.3151 5.96216 18.8815 6.39569L8.61621 16.661L8.61621 10.5926C8.61621 9.97846 8.11901 9.48126 7.50562 9.48204L7.37063 9.48204C6.75645 9.48204 6.25925 9.97924 6.26003 10.5926L6.26003 19.4774C6.26003 20.0916 6.75724 20.5888 7.37063 20.588L16.2554 20.588C16.5625 20.588 16.8414 20.4653 17.0423 20.2643Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedArrow);
export default __webpack_public_path__ + "static/media/red-arrow.3cbcbe8e0144bc2313ef68df43f264e2.svg";
export { ForwardRef as ReactComponent };